module.exports = __webpack_public_path__ + "img/bd.d90131c1.svg";